import React from 'react';

const Spinner = ({ className = '' }) => (
  <div className={`flex items-center justify-center py-20 ${className}`}>
    <style>
      {`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}
    </style>
    <div className="w-8 h-8 border-4 border-gray-200 border-t-rose-500 rounded-full" style={{ animation: 'spin 0.6s linear infinite' }} />
  </div>
);

export default Spinner;
